import React from 'react';
import Counter from '../../Components/Counter/Counter';
import TopClients from './../../Components/TopClients/TopClients';
import Contact from '../../Components/Contact/Contact';
import Hero from '../../Components/Hero/Hero';
import PopUpMailSubscription from '../../Components/Hero/PopUpMailSubcription';
import TenderSlider from '../../Components/TenderSliders/TenderSliders';
import TenderwiseServices from '../../Components/Landing/TenderwiseServices';
import Affiliator from '../../Components/Landing/Affiliator';
import TenderPublish, { TenderPublishLandingPage } from '../../Components/Landing/TenderPublish';

const HomePage = () => {
  return (
    <div>
      <Hero />
      {/* <PopUpMailSubscription /> */}
      <Counter />
      <TenderwiseServices />
      <TenderSlider/>
      <Affiliator />
      <TopClients />
      <TenderPublishLandingPage />
      <Contact />
    </div>
  );
};

export default HomePage;